import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Popover,
} from "@material-ui/core";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useContext, useState } from "react";
import ReportIcon from "@material-ui/icons/Report";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import moment from "moment";
import { LoginUserContext } from "../../../providers/LoginUserProvider";
import { putReportBoard } from "../../../utils/api/putReportBoard";
import { deleteBoard } from "../../../utils/api/deleteBoard";
import AccountIcon from "../../atoms/icons/AccountIcon";
import { useHistory, useParams } from "react-router-dom";
import { useBoard } from "../../../providers/BoardDetailProvider";
import ReportMessageBoardDialog from "./ReportDialog";
import MessageBoardNickname from "../../atoms/MessageBoardNickname";

const BoardHeader = () => {
  const currentUser = useContext(LoginUserContext);
  const {
    state: { boardDetailData },
    reportBoard,
  } = useBoard();
  const { category_id, board_id } =
    useParams<{ category_id: string; board_id: string }>();
  const history = useHistory();
  const { uid } = currentUser?.loginUser ?? {};
  const {
    avatar_url,
    nickname = "",
    created_at,
    id = 0,
    uid: authorId,
    title = "",
  } = boardDetailData ?? {};
  const [dialogReportOpened, setDialogReportOpened] = useState<boolean>(false);
  const [dialogDeleteOpened, setDialogDeleteOpened] = useState<boolean>(false);
  const [actionAnchorEl, setActionAnchorEl] =
    useState<HTMLButtonElement | null>(null);
  const handleClickActionButton = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setActionAnchorEl(event.currentTarget);
  };
  const handleCloseActionButton = () => {
    setActionAnchorEl(null);
  };
  const onToggleReportDialog = () => {
    setDialogReportOpened((pre) => !pre);
  };
  const onToggleDeleteDialog = () => {
    setDialogDeleteOpened((pre) => !pre);
  };
  const openActionPopover = Boolean(actionAnchorEl);
  const actionId = openActionPopover ? "action-popover" : undefined;
  const actions = [
    {
      icon: <EditOutlinedIcon fontSize="inherit" />,
      title: "編集",
      onClick: () => {
        history.push(
          `/message-board/categories/${category_id}/${board_id}/edit`
        );
      },
      rendering: uid === authorId,
    },
    {
      icon: <DeleteOutlineOutlinedIcon fontSize="inherit" />,
      title: "削除",
      onClick: onToggleDeleteDialog,
      rendering: uid === authorId,
    },
    {
      icon: <ReportIcon fontSize="inherit" />,
      title: "報告",
      onClick: onToggleReportDialog,
      rendering: uid !== authorId,
    },
  ];

  const handleReport = async (reason: string) => {
    await putReportBoard(id, reason).then((res) => {
      if (res.isSuccess) {
        reportBoard();
      }
    });
  };

  const handleDelete = async () => {
    await deleteBoard(id).then((res) => {
      if (res.isSuccess) {
        window.location.reload();
      }
    });
  };

  return (
    <div className={STBoardDetail.boardHeader}>
      <div className={STBoardDetail.boardHeaderBoardInfor}>
        {avatar_url ? (
          <img src={avatar_url} alt="" className={STBoardDetail.avatar} />
        ) : (
          <AccountIcon />
        )}
        <div className={STBoardDetail.boardHeaderBoardMetadata}>
          <MessageBoardNickname
            component="p"
            uid={authorId}
            nickname={nickname}
            className={STBoardDetail.boardHeaderBoardUserInfor}
          />
          <p className={STBoardDetail.boardHeaderBoardCreatedAt}>
            {moment(created_at).format("YYYY/MM/DD")}
          </p>
        </div>
      </div>
      <div className={STBoardDetail.boardHeaderActions}>
        <Button aria-describedby={actionId} onClick={handleClickActionButton}>
          <MoreHorizIcon />
        </Button>
        <Popover
          id={actionId}
          open={openActionPopover}
          anchorEl={actionAnchorEl}
          onClose={handleCloseActionButton}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div onClick={handleCloseActionButton}>
            {actions.map((action) => {
              const { icon, title, onClick, rendering = false } = action;
              if (!rendering) {
                return null;
              }
              return (
                <div
                  key={title}
                  onClick={onClick}
                  className={STBoardDetail.actionContainer}
                >
                  {icon} <p>{title}</p>
                </div>
              );
            })}
          </div>
        </Popover>
      </div>
      <ReportMessageBoardDialog
        isOpen={dialogReportOpened}
        onClose={onToggleReportDialog}
        handleReport={handleReport}
      />
      <Dialog
        open={dialogDeleteOpened}
        onClose={onToggleDeleteDialog}
        aria-labelledby="alert-dialog_delete-title"
        aria-describedby="alert-dialog-delete-description"
        className={STBoardDetail.dialog}
      >
        <DialogContent>
          <DialogTitle
            className={STBoardDetail.dialogTitle}
            id="alert-dialog_delete-title"
          >
            {title}
          </DialogTitle>
          <DialogContentText
            id="alert-dialog-delete-description"
            className={STBoardDetail.dialogDescription}
          >
            {`\nこの投稿を削除します\n投稿内のコメントも削除されます。\n※一度削除すると元には戻せません。よろしいですか？`}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          className={STBoardDetail.buttonGroup}
        >
          <Button
            className={STBoardDetail.backButton}
            onClick={onToggleDeleteDialog}
          >
            戻る
          </Button>
          <Button className={STBoardDetail.submitButton} onClick={handleDelete}>
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BoardHeader;
